"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = exports.DrawerContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_1 = require("../../tools/styled");
const defaultBreakpointInPixels = 1200;
exports.DrawerContext = react_1.createContext({
    expanded: true,
    setExpanded: (_newValue) => { },
    actionScrollHeight: 0,
    setActionScrollHeight: (_newValue) => { },
    handleScrollHeight: 0,
    setHandleScrollHeight: (_newValue) => { },
    breakpointInPixels: defaultBreakpointInPixels,
});
exports.Drawer = react_1.forwardRef((_a, ref) => {
    var { show = true, big = false, breakpointInPixels = defaultBreakpointInPixels } = _a, props = __rest(_a, ["show", "big", "breakpointInPixels"]);
    const [expanded, setExpanded] = react_1.useState(false);
    const [actionScrollHeight, setActionScrollHeight] = react_1.useState(0);
    const [handleScrollHeight, setHandleScrollHeight] = react_1.useState(0);
    return (jsx_runtime_1.jsx(exports.DrawerContext.Provider, Object.assign({ value: {
            expanded,
            setExpanded,
            actionScrollHeight,
            setActionScrollHeight,
            handleScrollHeight,
            setHandleScrollHeight,
            breakpointInPixels,
        } }, { children: jsx_runtime_1.jsx(ContainerDiv, Object.assign({ breakpointInPixels: breakpointInPixels, big: big, expanded: expanded, actionScrollHeight: actionScrollHeight, handleScrollHeight: handleScrollHeight, show: show, ref: ref }, props), void 0) }), void 0));
});
const ContainerDiv = styled_1.styled('div') `
  transition: all 0.25s;
  position: absolute;

  z-index: 10;

  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.primaryText};
  background: ${({ theme }) => theme.colors.primary};
  ${({ big }) => (big ? 'max-width: none; width: 70%;' : '')}

  @media screen and (max-width: ${({ breakpointInPixels }) => (breakpointInPixels - 0.5).toFixed(1)}px) {
    width: 100%;
    max-width: 100%;
    bottom: ${({ expanded }) => (expanded ? '0' : '-100%')};
    top: ${({ expanded }) => (expanded ? '0' : '100%')};
    left: 0;
    right: 0;
    margin-top: ${({ expanded, handleScrollHeight, actionScrollHeight, show }) => !show ? 0 : expanded ? 0 : -(handleScrollHeight + actionScrollHeight)}px;
  }

  @media screen and (min-width: ${({ breakpointInPixels }) => (breakpointInPixels - 0.5).toFixed(1)}px) {
    width: ${({ big }) => (big ? '70%' : '350px')};
    right: ${({ show }) => (show ? 0 : '-350px')};
    bottom: 0;
    top: 0;
  }

`;
//# sourceMappingURL=index.js.map